import createPersistedState from 'vuex-persistedstate';

export default ({ store }) => {
	createPersistedState({
		paths: [ 'userLogin.ageGate', 'userLogin.userRegistration', 'userLogin.timerPopup', 'userLogin.errorMessages.messageLogOut', 'userLogin.popupQuestionsIqosScienceLater' ],
		storage: window.sessionStorage,
	})(store);
};
